var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 116 108",
    viewBox: "0 0 116 108",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#g);enable-background:new    ;}\n\t.st1{clip-path:url(#e);}\n\t.st2{clip-path:url(#c);}\n\t.st3{clip-path:url(#ap);enable-background:new    ;}\n\t.st4{clip-path:url(#an);}\n\t.st5{clip-path:url(#al);}\n\t.st6{clip-path:url(#aj);fill:#FFFFFF;}\n\t.st7{clip-path:url(#ah);}\n\t.st8{clip-path:url(#ae);fill:#ABE8FF;}\n\t.st9{clip-path:url(#ac);}\n\t.st10{clip-path:url(#aa);fill:#FFFFFF;}\n\t\t.st11{clip-path:url(#y);fill:none;stroke:#CBCBCC;stroke-width:4.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{clip-path:url(#w);}\n\t.st13{clip-path:url(#t);fill:#ABE8FF;}\n\t.st14{clip-path:url(#r);}\n\t.st15{clip-path:url(#p);fill:#ABE8FF;}\n\t\t.st16{clip-path:url(#a);fill:none;stroke:#404042;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{clip-path:url(#a);fill:none;stroke:#404042;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st18{clip-path:url(#m);}\n\t.st19{clip-path:url(#j);fill:#FFFFFF;}\n\t.st20{clip-path:url(#h);fill:none;stroke:#404042;stroke-width:0.75;stroke-linecap:round;stroke-miterlimit:10;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "af",
    width: 116,
    height: 108
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#af"
  })), /*#__PURE__*/React.createElement("image", {
    width: 116,
    height: 108,
    clipPath: "url(#u)",
    overflow: "visible",
    xlinkHref: "936E8A86E8C7DC6B.png"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "k",
    x: -18,
    y: -171,
    width: 360,
    height: 640
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "f",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M6,1h312c2.2,0,4,1.8,4,4v96c0,2.2-1.8,4-4,4H6c-2.2,0-4-1.8-4-4V5C2,2.8,3.8,1,6,1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: -2,
    y: -3,
    width: 120,
    height: 114
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ao",
    x: 2,
    y: 1,
    width: 112,
    height: 105
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ao"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "am",
    x: 2,
    y: 1,
    width: 112,
    height: 105
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#am"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ak",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: -3,
    y: -4,
    width: 122,
    height: 115
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ai",
    x: 5.8,
    y: 82.8,
    width: 101.6,
    height: 5.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ag",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 0.8,
    y: 77.8,
    width: 111.6,
    height: 15.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "ad",
    points: "89.5 45.7 89.5 79.1 79.2 79.1 79.2 52.2 66 52.2 66 79.1 27.2 79.1 27.2 45.7 58.1 23.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ad"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ab",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 22.2,
    y: 18.2,
    width: 72.2,
    height: 65.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "z",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "17.5 50.5 59.6 20.8 101.1 50.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "x",
    points: "28.2 37.2 28.2 19.6 36.1 19.6 36.1 31.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "v",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 23.2,
    y: 14.6,
    width: 17.9,
    height: 27.6
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M67,80.3h13.2V53.4H67V80.3z M36.4,69.3h19.5V53.6H36.4V69.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "q",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    x: 31.4,
    y: 48.4,
    width: 53.7,
    height: 36.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "o",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "27.2 36 27.2 18.4 35.2 18.4 35.2 30.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "89.5 45.7 89.5 79.1 79.2 79.1 79.2 52.2 66 52.2 66 79.1 27.2 79.1 27.2 45.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 35.2,
    y: 52.4,
    width: 19.5,
    height: 15.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st16",
    points: "16.3 49.3 58.4 19.6 99.8 49.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m95 79.4h11.9m-100.1 0h15.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m68.1 68c0 0.1 0.1 0.1 0.2 0.1h0.6c0.1 0 0.1 0 0.2-0.1l0.4-0.5c0.3-0.4 0.2-1-0.1-1.4-0.4-0.4-1-0.4-1.4 0s-0.5 1-0.2 1.4l0.3 0.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "l",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 62.6,
    y: 60.8,
    width: 12.1,
    height: 12.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "i",
    x: 2,
    y: 1,
    width: 112,
    height: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 33.3,
    x2: 56.5,
    y1: 70.3,
    y2: 70.3
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHouse);
export default __webpack_public_path__ + "static/media/ic_house.c8f17d5b79f1a8f9185316b54e8837dc.svg";
export { ForwardRef as ReactComponent };